(ns frontend.test.page-sidebar
  (:require [reagent.core :as r]
            [frontend.routing :as routing]
            [frontend.utils :as fu]))

(defn sidebar-view [content state]
  [:div
   {:class-name (fu/cs "general-layout__sidebar general-layout__sidebar--fixed-to-left general-layout__sidebar--green"
                       (if (:sidebar-closed? @state)
                         "general-layout__sidebar--closed"
                         "general-layout__sidebar--open"))}
   [:span.mb-2 "Logo"]
   [content]
   [:button
    {:class-name "general-layout__sidebar-toggle-btn"
     :on-click   (fn []
                   (swap! state update :sidebar-closed? not))}
    (if (:sidebar-closed? @state) [:i.fas.fa-caret-right] [:i.fas.fa-caret-left])]])

(defn fifty-percent-columns []
  [:div.general-layout__page-content
   [:h3.title-h3.mb-2]
   [:div.page__row
    [:div.page__column.mb-3 "For grid let's use Bootstrap grid. with it we can have ROW/COL"]
    [:div.page__column.mb-3.w-100 ".general-layout__sidebar--green - we can change class names and colors"]
    [:div.page__column "Navbar and sidebar NOT fixed. Just remove these class names: .general-layout--fixed-sidebar, .general-layout--fixed-navbar, .general-layout__sidebar--fixed-to-left"]]])

(defn test-sidebar-content []
  [:ul.general-layout__sidebar-navigation
   [:li.list-item "One"]
   [:li.list-item "Two"]
   [:li.list-item "Three"]])

(defn navbar []
  [:div.header-navbar.header-navbar--light])

(defn percentage-fixed-width [state]
  [:div.page__content.page__content--fixed-percentage])

(defn layout-full-width-navbar [state content]
  [:div
   {:class-name (fu/cs "general-layout")}
   [navbar]

   [sidebar-view test-sidebar-content state]

   [content state]])

(defn content-container []
  [:div.general-layout__page-content.general-layout__page-content--fullscreen
   [:div.header-navbar]
   [:div "I am content!"]])

(defn layout-sidebar-navbar [state]
  [:div
   {:class-name (str "general-layout")}
   [sidebar-view test-sidebar-content state]
   [content-container state]])

(defmethod routing/render-view :test/page-sidebar [{:keys [route-params]}]
  (let [state (r/atom {:sidebar-closed? true})]
    (fn []
      (let []
        ;[layout-full-width-navbar state fifty-percent-columns]
        [layout-sidebar-navbar state]
        ))))
